// extracted by mini-css-extract-plugin
export default {"products":"Gt-z","card":"Ht-z","oosMessaging":"It-z"};